import {
  AuthRegisterConnectorApollo,
  SaleProductVariantsConnectorApollo,
} from '@front-activerse/common-components';
import SignUpContainer from './SignUpContainer';

const SignUpPage = ({
  redirectToPathAfterSuccessFromRoute,
  action,
  displayAppleButton = true,
  displayFacebookButton = true,
  displayGoogleButton = true,
  loginButtonURL,
}) => {
  const promoCode = global.localStorage.getItem('buyPromoCode');
  const productId = global.localStorage.getItem('buyProductId');

  return (
    <AuthRegisterConnectorApollo>
      {({ ...register }) => (
        <SaleProductVariantsConnectorApollo promoCode={promoCode} productId={+productId}>
          {({ productVariant }) => (
            <SignUpContainer
              {...register}
              redirectToPathAfterSuccess={redirectToPathAfterSuccessFromRoute}
              action={action}
              displayAppleButton={displayAppleButton}
              displayFacebookButton={displayFacebookButton}
              displayGoogleButton={displayGoogleButton}
              loginButtonURL={loginButtonURL}
              productVariant={productVariant}
            />
          )}
        </SaleProductVariantsConnectorApollo>
      )}
    </AuthRegisterConnectorApollo>
  );
};

export default SignUpPage;
